import Spacer from '$tablet-app/src/app/components/Spacer';
import { useRecordImage } from '@akin-home/images/react';
import { Meal } from '@akin-home/meals';
import { Text } from '@akin-home/text/native';
import { colors } from '@akin-home/theme';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import Checkbox from 'expo-checkbox';
import { StyleProp, ViewStyle } from 'react-native';
import styled from 'styled-components/native';
import { recipe_tile_image_edits } from '../../data/image_params';

interface Props {
  meal: Meal;
  isPast?: boolean;
  isFavourite?: boolean;

  style?: StyleProp<ViewStyle>;

  onPressViewRecipe?(recipe_id: string): void;
  onPressSwap?(meal: Meal): void;
  onPressEaten?(meal: Meal): void;
  onPressFavourite?(meal: Meal): void;
}

export const NewMealPlanTile = (props: Props) => {
  const {
    meal,
    isPast,
    isFavourite,
    onPressViewRecipe,
    onPressSwap,
    onPressEaten,
    onPressFavourite,
  } = props;

  const recipe = meal.recipes[0];

  const { source } = useRecordImage({
    record: meal,
    edits: recipe_tile_image_edits,
  });

  const handleSwapPress = () => onPressSwap?.(meal);
  const handleEatenPress = () => onPressEaten?.(meal);
  const handleFavouritePress = () => onPressFavourite?.(meal);

  const handleRecipePress = () => {
    if (recipe?.id) {
      onPressViewRecipe?.(recipe.id);
    }
  };

  return (
    <Container style={props.style}>
      <TouchableArea onPress={handleRecipePress}>
        <Image source={source} />

        <MealType>
          <Text variant="p2" weight="semibold" color="white">
            {meal.mealType}
          </Text>
        </MealType>

        <TitleContainer>
          <Text weight="semibold" numberOfLines={2}>
            {meal.title}
          </Text>
        </TitleContainer>
      </TouchableArea>

      <ButtonsContainer>
        {isPast ? (
          <BottomButton onPress={handleEatenPress}>
            <Checkbox
              value={meal.eaten}
              color={meal.eaten ? colors.primary[700] : undefined}
              onChange={handleEatenPress}
            />
            <Text
              weight="semibold"
              color={meal.eaten ? colors.primary[700] : undefined}
            >
              Eaten
            </Text>
          </BottomButton>
        ) : (
          <BottomButton onPress={handleSwapPress}>
            <FontAwesomeIcon icon={['far', 'exchange']} />
            <Text weight="semibold">Change</Text>
          </BottomButton>
        )}

        <Spacer width="1px" height="100%" color="#e6e8eb" />

        <BottomButton onPress={handleFavouritePress}>
          <FontAwesomeIcon
            icon={isFavourite ? 'star' : ['far', 'star']}
            color={isFavourite ? 'rgba(255, 191, 9, 1)' : undefined}
          />

          <Text weight="semibold">Favourite</Text>
        </BottomButton>
      </ButtonsContainer>
    </Container>
  );
};

const Container = styled.View`
  border-radius: 15px;

  background-color: white;
  overflow: hidden;
`;

const TouchableArea = styled.TouchableOpacity`
  flex: 1;
`;

const Image = styled.Image`
  height: 180px;
`;

const TitleContainer = styled.View`
  padding: 8px 16px;
  flex: 1;
`;

const ButtonsContainer = styled.View`
  border-top-color: #e6e8eb;
  border-top-width: 1px;
  flex-direction: row;

  align-items: center;
`;

const BottomButton = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;
  justify-content: center;
  height: 53px;
  flex: 1;
  gap: 8px;
`;

const MealType = styled.View`
  position: absolute;
  top: 18px;
  left: 12px;

  padding: 8px 10px;

  border-radius: 20px;
  background-color: #051633;

  border-color: white;
  border-width: 1px;

  align-items: center;
  justify-content: center;
`;
